import { WidgetsTypeEnum } from "src/app/enums/widgets/widgets-type.enum";
import { v4 as uuidv4 } from "uuid";

export abstract class WidgetsAbstract{
    // id: string = uuidv4();
    id: string;
    parentId?: string;

    template?: string;
    description?: string;

    // Optional
    properties?: any[];
    typeId?: number;
    // TODO: In uppercase from backend API. Check.
    // eslint-disable-next-line
    TypeName?: string;

    // Selected element of the tree
    isSelected: boolean = false;

    // Transient
    isEdit: boolean = false;

    abstract readonly icon: string;
    abstract name: string;
    abstract readonly widgetType: WidgetsTypeEnum;
    abstract readonly placeholderClassName: string;
    abstract readonly badge: string;

    constructor() {
        this.id = uuidv4();
    }

    updateId(): void {
        this.id = uuidv4();
    }

    getTemplate(): string {
        if (this.template) {
            return this.template;
        } else {
            return '';
        }
    }

    setTemplate(newTemplate: string): string {
        this.template = newTemplate;
        return this.template;
    }

    setName(newName: string): string {
        this.name = newName;
        return this.name;
    }

    /**
     * return true if node has sequence number
     *
     * @returns
     */
    hasSequence(): boolean{
        return false;
    }

    /**
     * Prototype creational design pattern
     * Copy existing object without making the code dependent on their classes.
     *
     * @param widget origin to clone from
     */
    abstract cloneFrom(widget: WidgetsAbstract): WidgetsAbstract;
}

